export const enumServerApps = {
  None: 0,
  SQLStandard: 1,
  SQLEnterprise: 2,
  Sybase: 3,
  SQLLite: 5,
  MySQL: 6,
  PostgreSQL: 7,
  ApachePHP: 8,
  IIS: 9,
  NGINX: 10,
  Cassandra: 11,
  Elasticsearch: 12,
  SAPHANA: 13,
  DB2: 14
};
